import React from "react";
import { useForm } from "react-hook-form";
import { Box, Button, Grid } from "@mui/material";
import RFG from "../../libs/inputs/RFG";
import MultiSelect from "../extra/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { ROLE, ROLEALL, PERMISSION } from "../../services/actions";

export default function Form({
  title,
  users = [],
  roles = [],
  companies = [],
  defaultValues = {},
  onSubmit = () => {},
  onChange = () => {},
  back = () => {},
}) {
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "all",
  });

  const selectedUsers = watch("users");
  React.useEffect(() => {
    onChange(selectedUsers, "users");
  }, [selectedUsers]);

  React.useEffect(() => {
    onChange(watch("company"), "company");
  }, [watch("company")]);

  return (
    <Box sx={{ p: 3 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 8 }}>
            <RFG
              name="company"
              label="Company"
              control={control}
              rules={{ required: true }}
              className="mb-2"
            >
              <select>
                <option value="">Select Company</option>
                {companies.map((company) => (
                  <option value={company.id}>{company.company_name}</option>
                ))}
              </select>
            </RFG>
            <RFG
              name="users"
              label="User Name"
              control={control}
              rules={{ required: true }}
              className="mb-2"
            >
              <select>
                <option value="">Select User</option>
                {users.map((user) => (
                  <option value={user.id}>{user.username}</option>
                ))}
              </select>
            </RFG>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
